import React from 'react';
import { Menu } from 'semantic-ui-react';

const Footer = (props) => {
    return (
        <Menu stackable borderless inverted style={{ margin: '0', padding: '0', height: '6vh', borderRadius: '0', border: 'none' }} fixed={props.fixed}>
            {/* <Menu.Item>
                <img src='/logo.png' />
            </Menu.Item> */}
            <Menu.Item style={{ fontWeight: '700', fontSize: '24px'}} link href="/">
                Kindl Go
            </Menu.Item>

            <Menu.Menu position='right'>
                <Menu.Item
                    name='Kontakt'
                    link
                    href='/kontakt'
                    style={{ fontWeight: 'bold' }}
                    >
                    Kontakt
        </Menu.Item>
        
                <Menu.Item
                    name='Impressum'
                    link
                    href='/impressum'
                    style={{ fontWeight: 'bold' }}
                >
                    Impressum
        </Menu.Item>

                <Menu.Item
                    name='Datenschutz'
                    link
                    href='/data-policy'
                    style={{ fontWeight: 'bold' }}
                >
                    Datenschutz
        </Menu.Item>
            </Menu.Menu>
        </Menu>
    )
};

export default Footer;